export const EMAIL_REGEXP = new RegExp(
  /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/
);

export const LATIN_AND_SPECIAL_CHARACTERS_ONLY_REGEXP = new RegExp(
  /^[a-zA-Z0-9\*\.!@#$%^&(){}[\]:;<>,?\/~_\+\-=|]{8,}$/
);
